// src/imageProcess
export const processImageUrl = (url , imgw, imgh) => {
    if(!imgh){imgh=''}
  if (url) {
    const processedUrl = url.replace('https://nonprod-media.webdunia.com/public_html', '');
    return `https://wd-image.webdunia.com/processimg/${imgw}x${imgh}/webp${processedUrl}`;
  }
  return '';
};